import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RelativeTimePipe } from './relative-time.pipe';
import { ExcerptPipe } from './excerpt.pipe';
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { FormatRowPipe } from './format-row.pipe';
import { DateTimePipe } from './datetime.pipe';
import { DateTimeFullPipe } from './full-date.pipe';
import { SafePipe } from './saft.pipe';
import { DateTimeFormatPipe } from './date-format.pipe';
import { currencyFormatPipe } from './currency.pipe';
import { DateDurationPipe } from './durationFormat.pipe';
import { AvatarPipe } from './avatar.pipe';

const pipes = [
  RelativeTimePipe,
  ExcerptPipe,
  GetValueByKeyPipe,
  FormatRowPipe,
  DateTimePipe,
  DateTimeFullPipe,
  SafePipe,
  DateTimeFormatPipe,
  currencyFormatPipe,
  DateDurationPipe,
  AvatarPipe
];

@NgModule({
  imports: [CommonModule],
  declarations: pipes,
  exports: pipes,
})
export class SharedPipesModule {}
